import axios from 'axios';
import { API_ENDPOINTS } from '../../../apiConfig';
export interface Tenant {
    id: string;
    name: string;
    subdomain: string;
    schemaName: string;
    contactEmail: string;
    mobileNo: string;
    whatsAppNo: string;
    status?:string ;
    comment?: string;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
  }
  export interface PaginatedResponse<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    number: number; // current page
    size: number;
  }
  
const API_BASE = `${API_ENDPOINTS.platform}/tenants`;

export interface DateRange {
    from?: string;
    to?: string;
  }
  
  export interface TenantFilterRequest {
    name?: string;
    status?: string[];
    subdomain?: string;
    contactEmail?: string;
    mobileNo?: string;
    whatsAppNo?: string;
    dateRange?: DateRange;
    pagination: {
      page: number;
      size: number;
    };
    sort: {
      field: string;
      direction: 'asc' | 'desc';
    };
  }
  
   
  export const fetchTenants = () => {
    return axios.get<Tenant[]>(API_BASE);
  };
  
  export const fetchTenantById = (id: string) => {
    return axios.get<Tenant>(`${API_BASE}/${id}`);
  };
  
  export const createTenant = (tenant: Partial<Tenant>) => {
    return axios.post<Tenant>(API_BASE, tenant);
  };
  
  export const updateTenant = (id: string, tenant: Partial<Tenant>) => {
    return axios.put<Tenant>(`${API_BASE}/${id}`, tenant);
  };
  
  export const deleteTenant = (id: string) => {
    return axios.delete(`${API_BASE}/${id}`);
  };
  
  export const fetchFilteredTenants = (filter: TenantFilterRequest) => {
    return axios.post<PaginatedResponse<Tenant>>(`${API_BASE}/filter`, filter);
  };

  export const searchTenantByNames = (keyword: string) => {
    return axios.get(`${API_BASE}/search-tenant-by-names`, {
      params: { keyword }
    });
  };